import { Component, OnInit } from '@angular/core';
import {CatcherService} from "../../../services/catcher.service";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-catchers',
  templateUrl: './catchers.component.html',
  styles: [
  ]
})
export class CatchersComponent implements OnInit {

  constructor(public catcherService: CatcherService, public authService: AuthService) { }

  ngOnInit(): void {
  }



}
